import moment from 'moment'
import consts from '@/mixins/consts'

export default {
  data: () => ({
    campoRequerido: [
      (v) => !!v || 'Campo obrigatório'
    ],
    campoRequeridoLogico: [
      (v) => (v === true || v === false) || 'Campo obrigatório'
    ]    
  }),
  created () {
    Object.assign(this, consts)
  },
  methods: {
    exibeAlerta (mensagem, tipo = 'error', timeout = 3000) {
      this.$store.commit('layout/definirAlerta', { mensagem, tipo, timeout })
    },
    goBack () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'home' })
    },
    isDate (data) {
      return !data || moment(data, this.formatDate, true).isValid()
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
